var $ = require('jquery');

$(document).ready(function() {
    initCover();
})
function initCover() {
    $('.page-section--main > .wp-block-cover').each(function() {
        var prev = $(this).prev();

        if(prev.length == 0) {
            $(this).addClass('-banner');
        }

        if($(this).hasClass('no-lazy')) {
            $(this).find('img').each(function() {
                $(this).attr('loading', 'eager');
            })
        }
    })
}
